import { rankingItems } from '@/mocks/darkwebData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1440px] mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              热度榜单
            </h2>
            <p className="text-foreground-600 text-sm mt-2">
              暗网社区最受关注的热门话题排行
            </p>
          </div>
          <div className="flex gap-2">
            <span className="px-3 py-1 text-xs font-medium bg-primary-500 text-background-50 rounded-full cursor-pointer whitespace-nowrap">
              本周
            </span>
            <span className="px-3 py-1 text-xs font-medium bg-background-200 text-foreground-600 rounded-full cursor-pointer whitespace-nowrap">
              本月
            </span>
            <span className="px-3 py-1 text-xs font-medium bg-background-200 text-foreground-600 rounded-full cursor-pointer whitespace-nowrap">
              全部
            </span>
          </div>
        </div>

        <div className="space-y-3">
          {rankingItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200/70 rounded-lg p-4 md:p-5 flex items-center gap-4 group hover:border-primary-300 transition-colors cursor-pointer"
            >
              <div
                className={`w-10 h-10 rounded-lg flex items-center justify-center shrink-0 font-heading text-lg font-bold ${
                  item.rank === 1
                    ? 'bg-accent-500 text-background-50'
                    : item.rank === 2
                      ? 'bg-primary-500 text-background-50'
                      : item.rank === 3
                        ? 'bg-secondary-500 text-background-50'
                        : 'bg-background-200 text-foreground-600'
                }`}
              >
                {String(item.rank).padStart(2, '0')}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 truncate">
                  {item.title}
                </h3>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-xs text-foreground-500">{item.heat} 热度</span>
                  <span className="text-xs text-primary-500">{item.change}</span>
                </div>
              </div>
              <span className="text-xs bg-background-100 text-foreground-600 px-2.5 py-1 rounded whitespace-nowrap shrink-0 hidden sm:inline-block">
                {item.tag}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}